var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_vm._t("top-buttons")],2)],1),_c('b-row',[_c('b-col',[(_vm.noBody)?_c('section',[_vm._t("filtering"),_vm._t("body")],2):_c('b-card',[_vm._t("filtering"),_vm._t("body")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }